/// <amd-module name="Agile/Directory/Components/DirectoryGrid/LoadingRow" />
import { ILoadingRow } from "Agile/Directory/Components/DirectoryGrid/DirectoryGrid.Props";
import { DetailsRow, IColumn, IDetailsRowProps } from "OfficeFabric/DetailsList";
import { Spinner } from "VSSUI/Spinner";
import * as React from "react";

import { DirectoryCSS } from "./DirectoryGridConstants";

export interface ILoadingRowProps extends IDetailsRowProps {
    columnKey: string;
    row: ILoadingRow;
    isGrouped: boolean;
}

export class LoadingRow extends React.PureComponent<ILoadingRowProps> {
    public render(): JSX.Element {
        return <DetailsRow {...this.props} onRenderItemColumn={this._renderCell} />;
    }

    private _renderCell = (row: ILoadingRow, index: number, column: IColumn): JSX.Element | undefined => {
        const { columnKey, isGrouped } = this.props;

        if (column.key === columnKey) {
            return (
                <div className={DirectoryCSS.DIRECTORY_ROWITEM}>
                    {isGrouped && <div className={DirectoryCSS.DIRECTORY_GROUP_SPACER} />}
                    <div className="directory-row-title directory-row-spinner">
                        <Spinner className="directory-spinner" />
                        Loading...
                    </div>
                </div>
            );
        }
    };
}
